module.exports = __webpack_public_path__ + "static/media/calendar.566a7862.svg";